"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const URLs_1 = require("../utility/URLs");
const react_router_1 = require("react-router");
const react_router_2 = require("react-router");
const PageContentEditor_1 = __importDefault(require("../components/PageContentEditor"));
const react_bootstrap_1 = require("react-bootstrap");
const helpers_1 = require("../../commonFiles/helpers");
const URLs_2 = require("../utility/URLs");
const ChangePageTitle_1 = __importDefault(require("../../commonFiles/ChangePageTitle"));
function PageEditor(props) {
    let { id } = (0, react_router_1.useParams)();
    // const [page, setpage] = React.useState(null)
    const [EditedPageContent, setEditedPageContent] = react_1.default.useState(null);
    const [title, settitle] = react_1.default.useState('');
    const [about, setabout] = react_1.default.useState('');
    const [description, setdescription] = react_1.default.useState('');
    const [source_url, setsource_url] = react_1.default.useState('');
    const [book_id, setbook_id] = react_1.default.useState('');
    const [books, setbooks] = react_1.default.useState([]);
    function setup() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.fetchPage(id); }), (data) => {
                // setpage(data); 
                settitle(data.title);
                setabout(data.about);
                setdescription(data.description);
                setsource_url(data.source_url);
                setEditedPageContent(data.page_content);
                setbook_id(data.book_id);
            }, 'PageEditor fetchPage', true);
            (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.fetchBooks({ withoutPagination: true }); }), setbooks, 'PageCreator fetchBooks', true);
        });
    }
    react_1.default.useEffect(() => {
        setup();
    }, []);
    react_1.default.useEffect(() => {
        console.log('PageEditor', EditedPageContent);
    }, [EditedPageContent]);
    function submit() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.editPage(id, title, about, source_url, EditedPageContent, book_id); }), (data) => { alert(data.success); setredirect(URLs_2.Routes.pageShow(id)); }, 'PageEditor submit', true);
        });
    }
    const [redirect, setredirect] = react_1.default.useState(null);
    if (redirect)
        return react_1.default.createElement(react_router_2.Redirect, { to: redirect });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "bg-white p-2" },
            react_1.default.createElement(ChangePageTitle_1.default, { pageTitle: title }),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5" }, "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', onChange: (e) => settitle(e.target.value), value: title !== null && title !== void 0 ? title : '' })),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { "aria-label": "Default select example", onChange: e => {
                    setbook_id(e.target.value);
                }, value: book_id !== null && book_id !== void 0 ? book_id : '' },
                react_1.default.createElement("option", null, "\u0627\u062E\u062A\u0631 \u0643\u062A\u0627\u0628"),
                books.map((book, bookIndex) => react_1.default.createElement("option", { key: bookIndex, value: book.id }, book.title))),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5" },
                    "\u062D\u0648\u0644 \u0627\u0644\u0635\u0641\u062D\u0629 ",
                    '(لايظهر للمتصفحين)'),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'textarea', onChange: (e) => setabout(e.target.value), value: about !== null && about !== void 0 ? about : '' })),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5" }, "\u0648\u0635\u0641 \u0644\u0644\u0635\u0641\u062D\u0629"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'textarea', onChange: (e) => setdescription(e.target.value), value: description !== null && description !== void 0 ? description : '' })),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { className: "my-2" },
                react_1.default.createElement(react_bootstrap_1.FormCheck.Label, { className: "fs-5" }, "\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0635\u062F\u0631"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'input', onChange: (e) => setsource_url(e.target.value), defaultValue: source_url !== null && source_url !== void 0 ? source_url : '' }))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(PageContentEditor_1.default, { pageContent: EditedPageContent, setEditedPageContent: setEditedPageContent }),
            react_1.default.createElement(react_bootstrap_1.Button, { onClick: submit }, "submit"))));
}
exports.default = PageEditor;
